webpackJsonp([148989285345645],{

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CharlotteImageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeroSmall = __webpack_require__(8);
	
	var _HeroSmall2 = _interopRequireDefault(_HeroSmall);
	
	var _LocationMicroNav = __webpack_require__(10);
	
	var _LocationMicroNav2 = _interopRequireDefault(_LocationMicroNav);
	
	var _LocationContent = __webpack_require__(9);
	
	var _LocationContent2 = _interopRequireDefault(_LocationContent);
	
	var _LocationRelated = __webpack_require__(11);
	
	var _LocationRelated2 = _interopRequireDefault(_LocationRelated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CharlotteLocation = function (_React$Component) {
	  _inherits(CharlotteLocation, _React$Component);
	
	  function CharlotteLocation() {
	    _classCallCheck(this, CharlotteLocation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CharlotteLocation.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HeroSmall2.default, { location: 'Charlotte, NC' }),
	      _react2.default.createElement(_LocationMicroNav2.default, null),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'Promoting Ridership',
	        title: 'Honoring a fallen champion',
	        story: ' In late May we joined NASCAR, MotoGP and AMA Supercross riders for a bike ride in Charlotte, North Carolina to honor the memory of Nicky Hayden. Hayden was a MotoGP world champion who was killed by by a distracted driver while cycling in Italy. Led by seven-time NASCAR champion Jimmie Johnson, the group paid tribute to Hayden by riding 69 (his race number) miles.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'Charlotte 1-1',
	        alt: 'Nicky Hayden memorial ride',
	        sizes: this.props.data.charlotteOneOneImage.sizes
	      }),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'Promoting Ridership',
	        title: 'Carolina on Our Mind',
	        story: 'Cyclofest, Interbike\u2019s East Coast event, is a cycling festival for both bicycle retailers and consumers\u2014a mix of demo bike opportunities, product displays, cyclocross races, food and music. The four-day event took place at the U.S. National Whitewater Center in Charlotte, NC. Our booth was front and center and we met retailers and other bike fanatics. One highlight: a chance to ride with mountain bike legend Ned Overend.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'Charlotte 2-1',
	        alt: 'Cyclofest expo picture',
	        sizes: this.props.data.charlotteTwoOneImage.sizes
	      }),
	      _react2.default.createElement(_LocationRelated2.default, {
	        prevLocationName: 'Detroit, MI',
	        prevLocationPath: 'detroit',
	        prevLocationImgPath: this.props.data.charlottePrevImage,
	        nextLocationName: 'Montana',
	        nextLocationPath: 'montana',
	        nextLocationImgPath: this.props.data.charlotteNextImage
	      })
	    );
	  };
	
	  return CharlotteLocation;
	}(_react2.default.Component);
	
	exports.default = CharlotteLocation;
	
	// GraphQL queries for each image, got to be a better way to do this but whatever for now
	
	var CharlotteImageQuery = exports.CharlotteImageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-charlotte-js-7da360a6f38cfdb65b12.js